document.addEventListener('DOMContentLoaded', () => {
  if (customElements.get('tech-showcase-carousel')) return;

  class TechShowcaseCarousel extends HTMLElement {
    constructor() {
      super();
      this.swiper = null;
      this.viewportObserver = null;
      this.prefersReducedMotion = window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches;
    }

    connectedCallback() {
      this.container = this.querySelector('.swiper-container');
      this.slideCount = this.querySelectorAll('.swiper-slide').length;

      if (!this.container || typeof Swiper === 'undefined') {
        if (typeof Swiper === 'undefined') {
          console.error('Swiper is not defined.');
        }
        return;
      }

      this.initSwiper();
      this.initViewportAutoplay();
    }

    disconnectedCallback() {
      if (this.viewportObserver) {
        this.viewportObserver.disconnect();
        this.viewportObserver = null;
      }

      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
    }

    isAutoplayEnabled() {
      return (
        this.dataset.autoplay !== 'false' &&
        !this.prefersReducedMotion &&
        this.slideCount > 1
      );
    }

    initSwiper() {
      const enableLoop = this.slideCount > 1;
      const enableAutoplay = this.isAutoplayEnabled();
      const autoplayDelay = Number(this.dataset.autoplayDelay) || 4000;

      const options = {
        slidesPerView: 'auto',
        spaceBetween: 20,
        loop: enableLoop,
        loopedSlides: this.slideCount,
        loopAdditionalSlides: 2,
        watchOverflow: true,
        resistance: true,
        resistanceRatio: 0,
        roundLengths: true,
        observer: true,
        observeParents: true,
        grabCursor: true,
        simulateTouch: true,
        speed: 600,
        autoplay: enableAutoplay
          ? {
              delay: autoplayDelay,
              disableOnInteraction: false,
            }
          : false,
        breakpoints: {
          850: {
            spaceBetween: 10,
          },
        },
      };

      this.swiper = new Swiper(this.container, options);

      if (enableAutoplay && this.swiper.autoplay) {
        this.swiper.autoplay.stop();
      }
    }

    initViewportAutoplay() {
      if (
        !this.isAutoplayEnabled() ||
        !this.swiper ||
        !this.swiper.autoplay
      ) {
        return;
      }

      this.viewportObserver = new IntersectionObserver(
        ([entry]) => {
          if (!this.swiper || !this.swiper.autoplay) return;

          if (entry.isIntersecting && entry.intersectionRatio >= 0.25) {
            this.swiper.autoplay.start();
          } else {
            this.swiper.autoplay.stop();
          }
        },
        {
          threshold: [0, 0.25, 0.5, 0.75, 1],
          rootMargin: '0px 0px -8% 0px',
        }
      );

      this.viewportObserver.observe(this);
    }
  }

  customElements.define('tech-showcase-carousel', TechShowcaseCarousel);
});
